import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GuidedTourService } from "@edp-components/ngx-guided-tour/guided-tour.service";
import { environment } from "@edp-environments/environment";
import { OnboardingWhatsNew, OnboardingStep } from "@edp-models/onboarding.model";
import { EnvService } from "@edp-services/env.service";
import { OnboardingService } from "@edp-services/onboarding.service";
import { SetCompleteOnboarding, SetOnboardingWhatsNew } from "@edp-store/actions/onboarding.actions";
import { getOnboardingWhatsNew } from "@edp-store/selectors/onboaring.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { take, filter } from "rxjs/operators";

@Component({
    selector: "edp-widget-onboarding-whats-new",
    templateUrl: "./edp-widget-onboarding-whats-new.component.html",
    styleUrls: ["./edp-widget-onboarding-whats-new.component.scss"],
})
export class EdpWidgetOnboardingWhatsNewComponent implements OnInit {
    onboardingWhatsNew: OnboardingWhatsNew;
    prefixPathImage: string;

    constructor(
        private store: Store<IAppState>,
        private router: Router,
        private onboardingService: OnboardingService,
        private guidedTourService: GuidedTourService,
        protected env: EnvService,
    ) {
        this.prefixPathImage = `${env.appUrl()}/resource/image/`;
    }

    ngOnInit(): void {
        this.store
            .pipe(
                select(getOnboardingWhatsNew),
                filter(o => !!o),
                take(1)
            )
            .subscribe(data => {
                this.onboardingWhatsNew = data;
            });
    }

    public action(): void {
        this.store.dispatch(new SetCompleteOnboarding(this.onboardingWhatsNew.id, "complete"));
        this.onboardingService.setoperationHistoryService(this.onboardingWhatsNew.id, this.onboardingWhatsNew.type, "CLICKED");

        if (!!Array.isArray(this.onboardingWhatsNew.action)) {
            const tour = this.onboardingService.getOnboarding(
                this.onboardingWhatsNew.id,
                this.onboardingWhatsNew.action as Array<OnboardingStep>,
                this.onboardingWhatsNew.type
            );
            setTimeout(() => {
                this.guidedTourService.startTour(tour);
            }, 100);
            return;
        }

        if (this.onboardingWhatsNew.action.page) {
            this.store.dispatch(new SetOnboardingWhatsNew(null));
            this.router.navigate([this.onboardingWhatsNew.action.page]);
        }
    }
}
